import { useEffect, useState } from 'react'

/**
 * Reports whether the page runs on an Android device (browser or Android app WebView).
 * Starts as `false` so server and first client render match, then checks the user agent.
 */
export const useIsAndroidDevice = () => {
  const [isAndroidDevice, setIsAndroidDevice] = useState(false)

  useEffect(() => {
    setIsAndroidDevice(/android/i.test(window.navigator.userAgent))
  }, [])

  return isAndroidDevice
}

export default useIsAndroidDevice
